export default __webpack_public_path__ + "static/media/monitor.04a7bacb.svg";